// extracted by mini-css-extract-plugin
module.exports = {"maxWidth":"MaxWidth_maxWidth__KA1tO"};